import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { images } from '../../constants';

const AboutUs = () => (
  <div className='app__aboutUs app__bg flex__center section__padding' id='about' >
    <div className='app__aboutUs-content flex__center' >
      <div className='app__aboutUs-content_about' >
        <h1 className='headtext__cormorant' >About Us</h1>
        <img src={images.spoon} alt='spoon' className='spoon__img' />
        <p className='p__opensans' >Located in Abuja, Nigeria, we offer lively dining experiences, top-notch service and quality cuisines from around the world. We have some of the finest chefs in the country, awesome side attractions, and we take pride in the beauty and aesthetics of our environment.</p>
        <a href='#chef' >
          <button type='button' className='custom__button' >Know More</button>
        </a>
      </div>
      <div className='app__aboutUs-content_knife flex__center' >
        <LazyLoadImage src={images.knife} alt='knife' effect='blur' />
      </div>
      <div className='app__aboutUs-content_history' >
        <h1 className='headtext__cormorant' >Our History</h1>
        <img src={images.spoon} alt='spoon' className='spoon__img' />
        <p className='p__opensans' >Our founder, Mr Ayo Tolu Sam, started out in 2016 with a food truck, in what has grown to be the global brand that Foodiverse is today.
        <br/>The restaurant in Abuja was launched in September 2019, and continues to grow till date. </p>
        <a href='#chef' >
          <button type='button' className='custom__button' >Know More</button>
        </a>
      </div>
    </div>
  </div>
);

export default AboutUs;
